import { memo, useCallback } from "react";
import { Marker, Tooltip } from "react-leaflet";
import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import { useStores } from "stores/setup/use-store";
import { ISensorMeasuredData } from "types/ISensorMeasuredData";
import { EnvironmentalType } from "enum/EnvironmentalType";
import SensorMarkerIcon from "./SensorMarkerIcon";
import { TooltipContent } from "components/TooltipComponent/ToolltipComponent";

interface SensorSelectionMarkerProps {
  sensor: ISensorMeasuredData;
  isSelected: boolean;
}

/**
 * Renders a single sensor marker in Sensor Selection Mode.
 * On click, toggles sensor selection in forecastChartPageStore.
 */
const SensorSelectionMarker = memo(
  ({ sensor, isSelected }: SensorSelectionMarkerProps) => {
    const {
      dataStores: { forecastChartPageStore },
    } = useStores();

    const icon = divIcon({
      html: renderToStaticMarkup(
        <SensorMarkerIcon
          sensorItem={sensor}
          isSelected={isSelected}
          tabStateActivity={EnvironmentalType.PRECIPITATION}
          isSensorSelectionMode
        />,
      ),
    });

    const handleClick = useCallback(() => {
      forecastChartPageStore.toggleSensorSelection(sensor.station_id);
    }, [forecastChartPageStore, sensor.station_id]);

    return (
      <Marker
        position={[
          parseFloat(sensor.station_lat),
          parseFloat(sensor.station_lon),
        ]}
        icon={icon}
        eventHandlers={{ click: handleClick }}
      >
        <Tooltip>
          <TooltipContent
            zoomLevel={forecastChartPageStore.mapZoom}
            title={sensor.station_name}
          />
        </Tooltip>
      </Marker>
    );
  },
);

export default SensorSelectionMarker;
